export default function () {
    $('.forgot-password button').on('click', () => {
        const target = $('#password-reset').data('target');

        $('#loginModal').modal('hide');
        $(target).modal('show');
    });
}
